<div class="autocomplete-div-field">
  <mat-form-field class="d-block f-right full-width" appearance="outline">
    <mat-label>{{ 'forms:' + field.label | i18nextCap }}</mat-label>
    <input
      type="text"
      matInput
      [formControl]="$any(this.formGroup.controls[this.field.name])"
      [matAutocomplete]="auto"
      [name]="field.name"
      [placeholder]="field.placeholder ? (field.placeholder | i18nextCap) : ''"
      [attr.data-testid]="field.dataTestId"
      (focusout)="checkValueOnFocusOut()"
      (keydown.enter)="onEnter($event)"
    />
    <mat-autocomplete
      #auto="matAutocomplete"
      [displayWith]="displayFn.bind(this)"
      (optionSelected)="onSelected($event)"
    >
      @if (this.field.autocomplete) {
        @if (this.field.autocomplete.firstOption) {
          <mat-option
            [value]="this.field.autocomplete.firstOption.value || null"
          >
            <div class="custom-first-option">
              <div
                class="fa-icon-div"
                [ngClass]="
                  this.field.autocomplete.firstOption.iconColor
                    ? this.field.autocomplete.firstOption.iconColor + '-icon'
                    : ''
                "
              >
                @if (this.field.autocomplete.firstOption.fontAwesomeIcon) {
                  <fa-icon
                    [icon]="this.field.autocomplete.firstOption.fontAwesomeIcon"
                    size="sm"
                  ></fa-icon>
                }
              </div>
              {{
                'forms:' + this.field.autocomplete.firstOption.label
                  | i18nextCap
              }}
            </div>
          </mat-option>
        }
      }
      @for (item of filteredOptions | async; track item) {
        <mat-option
          [value]="
            field.autocomplete?.value ? field.autocomplete?.value(item) : item
          "
        >
          @if (item.icon) {
            <mat-icon>{{ item.icon }}</mat-icon>
          }
          @if (
            field.translate &&
            (field.displayValue ? field.displayValue(item) : item.name)
          ) {
            {{
              'forms:' +
                (field.displayValue ? field.displayValue(item) : item.name)
                | i18nextCap
            }}
          }
          @if (
            !field.translate &&
            (field.displayValue ? field.displayValue(item) : item.name)
          ) {
            {{ field.displayValue ? field.displayValue(item) : item.name }}
          }
        </mat-option>
      }
    </mat-autocomplete>

    @if (this.formGroup.controls[this.field.name].hasError('required')) {
      <mat-error>{{ 'validation:youMustEnterAValue' | i18nextCap }}</mat-error>
    } @else {
      @if (this.formGroup.controls[this.field.name].hasError('noFound')) {
        <mat-error>{{
          'validation:selectItemThatExistsInList' | i18nextCap
        }}</mat-error>
      }
    }
  </mat-form-field>
  @for (button of field.buttons; track button) {
    <button
      mat-icon-button
      (click)="button.onClick()"
      color="primary"
      type="button"
      [disabled]="button.disabled$ ? (button.disabled$ | async) : undefined"
    >
      @if (button.iconName) {
        <mat-icon>
          {{ button.iconName }}
        </mat-icon>
      }
      @if (button.fontAwesomeIconName) {
        <div class="fa-icon-div">
          <fa-icon [icon]="button.fontAwesomeIconName" size="lg"></fa-icon>
        </div>
      }
    </button>
  }
</div>
